// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JuQXk9Nz5g40THyflWKU {
  height: 1px;
  margin: 16px 0;
  background-color: var(--grey-color-200);
}

.GaUAYQTXvWQILP5hFZTD {
  font-family: var(--font-stack-full-medium);
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
}

.GgaFKDiCq4ULeDKMEWPY {
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/CohortInsightsSkillsTable/CohortInsightsSkillsTable.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF","sourcesContent":[".cohortTableDivider {\n  height: 1px;\n  margin: 16px 0;\n  background-color: var(--grey-color-200);\n}\n\n.cohortTableHeader {\n  font-family: var(--font-stack-full-medium);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n}\n\n.cohortTableHeaderContainer {\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cohortTableDivider": `JuQXk9Nz5g40THyflWKU`,
	"cohortTableHeader": `GaUAYQTXvWQILP5hFZTD`,
	"cohortTableHeaderContainer": `GgaFKDiCq4ULeDKMEWPY`
};
export default ___CSS_LOADER_EXPORT___;
